import React, { useState } from 'react';
import {
    CenterCircularProgress,
    LazyBreadcrumb,
    NavigateNotFound,
    SidePanelCard,
    useModal,
    ModalConfirm,
} from '@europrocurement/flexy-components';
import { Box, Grid } from '@mui/material';
import { FlexyDatatableFilters } from '@europrocurement/flexy-datatable/components/FlexyDatatableFilters/FlexyDatatableFilters';
import { Formalite } from '@europrocurement/l2d-domain';
import { FORMALITY_LIST } from '../../constants/paths';
import CompatibilitiesTable from './CompatibilitiesTable';
import CompatibilitiesSearch from './CompatibilitiesSearch';
import useCompatibility from '../../hooks/useCompatibility';

const CompatibilitiesShow: React.FunctionComponent = function () {
    const [editionMode, setEditionMode] = useState(false);
    const { modalActions } = useModal();
    const { requestState, formalities, searchOpts, getFilteredFormalities, toggleCompatibility } =
        useCompatibility();

    if (requestState.isProcessing) {
        return <CenterCircularProgress sx={{ height: '70vh' }} />;
    }

    if (requestState.error) {
        NavigateNotFound();

        return null;
    }

    const onToggleCompatibility = (formality: Formalite, compatibility: Formalite) => {
        if (editionMode) {
            toggleCompatibility(formality, compatibility);

            return;
        }

        modalActions.call(
            <ModalConfirm
                onConfirm={() => {
                    setEditionMode(true);
                    toggleCompatibility(formality, compatibility);
                }}
                message="Êtes vous sur de vouloir modifier les informations de ce tableau ?"
            />,
        );
    };

    return (
        <>
            <LazyBreadcrumb
                path={[{ path: 'Formalités', link: FORMALITY_LIST }, 'Liste des compatibilités']}
            />
            <Box>
                <SidePanelCard
                    rightMenu={<FlexyDatatableFilters filtersOpts={searchOpts.filtersOpts} />}
                    sx={{
                        width: '100%',
                        maxHeight: '90vh',
                    }}
                >
                    <Grid
                        container
                        flexDirection="column"
                        sx={{ padding: '25px', boxSizing: 'border-box' }}
                    >
                        <Grid
                            item
                            sx={{ maxWidth: '100%' }}
                        >
                            <CompatibilitiesSearch searchOpts={searchOpts} />
                        </Grid>
                        <Grid
                            item
                            sx={{
                                maxWidth: '100%',
                                overflowX: 'scroll',
                            }}
                        >
                            <CompatibilitiesTable
                                formalities={formalities}
                                filteredFormalities={getFilteredFormalities()}
                                onToggleCompatibility={onToggleCompatibility}
                            />
                        </Grid>
                    </Grid>
                </SidePanelCard>
            </Box>
        </>
    );
};

export default CompatibilitiesShow;
